import React from 'react';
import { connect } from 'react-redux';

import IframeEmbedSection from './iframe_embed.jsx';

import {
  getRenderAsMobile,
  getSectionSingletonContentItem
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  getHeightStyle,
  getIsVisibleOnMobile
} from 'zoomforth_codesbane_viewer/lib/sections.js';

import userAgentDetect from 'zoomforth_zfutils/useragent_detect.js';

const mapStateToProps = (state, { section }) => {
  const isMobile = getRenderAsMobile(state) || userAgentDetect.isMobile.isAnyRealDevice();
  const contentItem = getSectionSingletonContentItem(state, section);
  const height = getHeightStyle(section);

  return {
    height,
    isMobile,
    shouldShowSkipLink: true,
    uuid: contentItem ? contentItem.uuid : null,
    iframeEmbedUrl: contentItem ? contentItem.iframe_embed_url : null,
    iframeTitle: contentItem ? contentItem.iframe_title : null,
  };
};

const mapDispatchToProps = () => ({});

const IframeEmbedSectionSwitcher = ({ isMobile, ...props }) => {
  if (!props.iframeEmbedUrl) {
    return null;
  } else if (isMobile && !getIsVisibleOnMobile(props.section)) {
    return null;
  }
  return <IframeEmbedSection {...props} />;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IframeEmbedSectionSwitcher);
